import { getMessagesControl } from 'providers/Toast';

export const MESSAGES = getMessagesControl({
  startAuthorizationFail: (t) => ({
    title: t('error-while-authorizing-project'),
    type: 'error',
  }),

  ProjectAlreadyAuthorized: (t) => ({
    title: t('project-is-already-authorized-to-start'),
    type: 'error',
  }),

  startAuthorizationSuccess: (t) => ({
    title: t('project-authorized-to-start'),
    type: 'success',
  }),

  repriceCommentOnNoChange: (t) => ({
    title: t('comment-required'),
    description: t('its-required-if-a-value-was-not-changed') as string,
  }),

  invoiceRepriceRequiresChanges: (t) => ({
    title: t('invoice-request-requires-changes'),
    type: 'error',
  }),

  outsourcingFailed: (t) => ({
    title: t('error-while-reviewing-outsource'),
    type: 'error',
  }),

  outsourcingSuccess: (t, state) => ({
    title: t('outsource-state-with-success', { state }),
    type: 'success',
  }),

  addCountryCommentOnReject: (t) => ({
    title: t('comment-required'),
    description: t('its-required-if-the-request-was-reject') as string,
  }),
});
